import React from 'react'

import SearchImgSvg from './../images/search.svg'
import vsealGIF from './../images/vseal.gif'
import Image from './Image'

const Footer = () => (
    <footer>
        <div className="container-fluid footer">
            <div className="container">
                <div className="row">
                    <div className="col-md-4 cxCare">
                        <h3>Customer Care</h3>
                        <ul className="fa-ul">
                            <li><i className="glyph-phone"></i>800-222-8985</li>
                            <li><i className="glyph-phone"></i>Mon-Fri 7:00am to 7:00pm PST (10:00am - 10:00pm EST)</li>
                            <li><i className="glyph-phone"></i>Spanish Hours (8:00am - 5:00pm PST)</li>
                            <li><a href="mailto:support@instantcheckmate.com"><i className="envelope"></i>support@instantcheckmate.com</a></li>
                        </ul>
                        <p>Our Customer Care team is friendly and helpful.</p>
                    </div>
                    <div className="col-md-4">
                        <h3>Most Helpful Articles</h3>
                        <ul className="fa-ul">
                            <li><i className="paper-fold"></i><a href="/cancel-account/">Cancel your account</a></li>
                            <li><i className="paper-fold"></i><a href="/change-password/">Change your password</a></li>
                            <li><i className="paper-fold"></i><a href="/login-account/">Login to your account</a></li>
                            <li><i className="paper-fold"></i><a href="/background-search/">Background search anyone</a></li>
                        </ul>
                    </div>
                    <div className="col-md-4">
                        <h3>Find Someone Today</h3>
                        <form className="icm_search form-inline" method="get" target="_top" action="https://www.instantcheckmate.com/search/?">
                            <div className="form-wrapper">
                                <div className="form-group search-by-name">
                                    Search By Name
</div>
                                <div className="form-group fname">
                                    <input id="fname-l" required="" className="form-control" type="text" name="fname" placeholder="First" tabIndex="7" pattern="[a-zA-Z- ]+" />
                                </div>
                                <div className="form-group lname">
                                    <input id="lname-l" required="" className="form-control" type="text" name="lname" placeholder="Last" tabIndex="8" pattern="[a-zA-Z- ]+" />
                                </div>
                                <div className="form-group state">
                                    <select className="form-control state" name="state" tabIndex="9">
                                        <option value="">All States</option>
                                        <option value="AL">Alabama</option>
                                        <option value="AK">Alaska</option>
                                        <option value="AZ">Arizona</option>
                                        <option value="AR">Arkansas</option>
                                        <option value="CA">California</option>
                                        <option value="CO">Colorado</option>
                                        <option value="CT">Connecticut</option>
                                        <option value="DE">Delaware</option>
                                        <option value="FL">Florida</option>
                                        <option value="GA">Georgia</option>
                                        <option value="HI">Hawaii</option>
                                        <option value="ID">Idaho</option>
                                        <option value="IL">Illinois</option>
                                        <option value="IN">Indiana</option>
                                        <option value="IA">Iowa</option>
                                        <option value="KS">Kansas</option>
                                        <option value="KY">Kentucky</option>
                                        <option value="LA">Louisiana</option>
                                        <option value="ME">Maine</option>
                                        <option value="MD">Maryland</option>
                                        <option value="MA">Massachusetts</option>
                                        <option value="MI">Michigan</option>
                                        <option value="MN">Minnesota</option>
                                        <option value="MS">Mississippi</option>
                                        <option value="MO">Missouri</option>
                                        <option value="MT">Montana</option>
                                        <option value="NE">Nebraska</option>
                                        <option value="NH">New Hampshire</option>
                                        <option value="NJ">New Jersey</option>
                                        <option value="NM">New Mexico</option>
                                        <option value="NY">New York</option>
                                        <option value="NC">North Carolina</option>
                                        <option value="ND">North Dakota</option>
                                        <option value="OH">Ohio</option>
                                        <option value="OK">Oklahoma</option>
                                        <option value="OR">Oregon</option>
                                        <option value="PA">Pennsylvania</option>
                                        <option value="RI">Rhode Island</option>
                                        <option value="SC">South Carolina</option>
                                        <option value="SD">South Dakota</option>
                                        <option value="TN">Tennessee</option>
                                        <option value="TX">Texas</option>
                                        <option value="UT">Utah</option>
                                        <option value="VT">Vermont</option>
                                        <option value="VA">Virginia</option>
                                        <option value="WA">Washington</option>
                                        <option value="DC">Washington D.C.</option>
                                        <option value="WV">West Virginia</option>
                                        <option value="WI">Wisconsin</option>
                                        <option value="WY">Wyoming</option>
                                    </select>
                                    <button id="footer-search" type="submit" className="btn submit-button" tabIndex="4">Begin Search <img alt="" src={SearchImgSvg} /></button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div className="container">
            <div className="row">
                <p className="disclaimer">DISCLAIMER: You may not use our service or the information it provides to make decisions about consumer credit, employment, insurance, tenant screening, or any other purpose that would require FCRA compliance. Instant Checkmate does not provide consumer reports and is not a consumer reporting agency. (These terms have special meanings under the Fair Credit Reporting Act, 15 USC 1681 et seq., ("FCRA"), which are incorporated herein by reference.) The information available on our website may not be 100% accurate, complete, or up to date, so do not use it as a substitute for your own due diligence, especially if you have concerns about a person's criminal history. Instant Checkmate does not make any representation or warranty about the accuracy of the information available through our website or about the character or integrity of the person about whom you inquire. For more information, please review Instant Checkmate Terms of Use.</p>
                <p className="copyright">Copyright ©
2021 Instant Checkmate, Inc. All Rights Reserved.</p>
            </div>
            <div className="row clout">
                <div className="col-md-4">
                    <a href="https://www.instantcheckmate.com">
                        <Image imgsrc="instant-checkmate-logo-400px.png" style={{ width: '180px', margin: '0 auto' }} alt="commissions icon" />
                    </a>
                </div>
                <div className="col-md-4">
                    <a href="https://www.bbb.org/us/ca/san-diego/profile/internet-service/instant-checkmate-inc-1126-172003447">
                        <Image imgsrc="bbb.png" style={{ width: '180px', margin: '0 auto' }} alt="Better Business Bureau Logo" />
                    </a>
                </div>
                <div className="col-md-4">
                    <a href="https://trustsealinfo.websecurity.norton.com/splash?form_file=fdf/splash.fdf&amp;dn=www.instantcheckmate.com&amp;lang=en">
                        <img style={{ maxWidth: '100px' }} src={vsealGIF} alt="Norton Secured Seal" />
                    </a>
                </div>
            </div>
            <div className="app">
                <p><b>Download the Instant Checkmate App.</b></p>
                <p>Available on <a href="https://play.google.com/store/apps/details?id=com.instantcheckmate.app">Google Play</a> and the <a href="https://apps.apple.com/us/app/instant-checkmate/id1349460274">App Store</a>.</p>
            </div>
        </div>
    </footer>
)

export default Footer